// extracted by mini-css-extract-plugin
module.exports = {"container":"Company_container__pqNkg","logo":"Company_logo__Xd3wz","logoImage":"Company_logoImage__OU0PB","title":"Company_title__O_cy0","delimiter":"Company_delimiter__T6jTC"};